import { Login, PasswordRecovery } from '../processes/Login';

export const LoginRouter = Login;
export const PasswordRecoveryRouter = PasswordRecovery;
